import { useEffect } from 'react';
import { setSEOAuthor, setSEODescription, setSEOImage, setSEOArticleTags, setSEORobots, setSEOTitle, setSEOUrl, setSEOThemeColor, SEOImage } from '@utils/seo';
import { useData } from './useData';

export const useSEOMetatags = (props: {
    title: string;
    description: string;
    tags?: string[];
    image?: SEOImage;
    url: string;
    index: boolean;
}) => {
    const { allSettings } = useData();

    const logoItem = allSettings?.data?.layouts?.find((item) => item.name === 'logo');
    const logoSrc = logoItem?.value || '';

    const DEFAULT_IMAGE = {
        src: logoSrc,
        type: 'image/png',
        alt: allSettings?.data?.marketplaceName || '',
        width: 201,
        height: 42,
    };

    const themeColor = allSettings?.data?.layouts?.find((item) => item.name === 'primary color')?.value || '';

    useEffect(() => {
        setSEOTitle(props.title);
        setSEODescription(props.description);
        setSEOArticleTags(props.tags?.filter((item) => item !== '') || []);
        setSEOImage(props.image?.src ? props.image : DEFAULT_IMAGE);
        setSEORobots(props.index);
        setSEOUrl(props.url);
        setSEOThemeColor(themeColor);

        // reset meta tags on component unmount
        return () => {
            setSEOTitle('');
            setSEODescription('');
            setSEOArticleTags([]);
            setSEOImage(DEFAULT_IMAGE);
            setSEOUrl('');
            setSEORobots(true);
            setSEOThemeColor('');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.title, props.description, JSON.stringify(props.tags), props.image, props.index, props.url, themeColor, logoSrc]);

    useEffect(() => {
        setSEOAuthor(allSettings?.data?.seo_author || '');

        // reset meta tags on component unmount
        return () => {
            setSEOAuthor('');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allSettings?.data?.seo_author]);

    return null;
};
